var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-input',{attrs:{"value":_vm.input_value,"state":_vm.state},on:{"keydown":function($event){return _vm.clean($event)},"keyup":function($event){return _vm.onkeyup($event)}}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }